import React from 'react';

const PricingAnalysis = () => {
  // Mock data representing the exact rows from your Figma design
  const bidRecords = [
    { id: 1, customer: 'PowerGrid Systems', plan: 'Advanced', category: 'Electrical', state: 'Maharashtra', dept: 'PGCIL', tender: 'Grid Modernization Project', tenderVal: '₹18.5Cr', bidVal: '₹16.2Cr', discount: 12.4, rank: 'L2', result: 'Lost', range: '>10Cr', month: 'Dec 2025' },
    { id: 2, customer: 'BuildPro Solutions', plan: 'Advanced', category: 'Construction', state: 'Maharashtra', dept: 'NHAI', tender: 'Highway Bridge Construction', tenderVal: '₹12.4Cr', bidVal: '₹9.8Cr', discount: 21, rank: 'L1', result: 'Won', range: '>10Cr', month: 'Nov 2025' },
    { id: 3, customer: 'InnovateTech', plan: 'Advanced', category: 'IT Services', state: 'Telangana', dept: 'APSFL', tender: 'Digital Infrastructure - AP', tenderVal: '₹9.2Cr', bidVal: '₹8.4Cr', discount: 8.7, rank: 'L3', result: 'Lost', range: '5-10Cr', month: 'Jan 2026' },
    { id: 4, customer: 'Semiconductors Ltd', plan: 'Premium', category: 'Electronics', state: 'Karnataka', dept: 'HAL', tender: 'Avionics Testing Equipment', tenderVal: '₹9.2Cr', bidVal: '₹8.1Cr', discount: 12, rank: 'L1', result: 'Won', range: '5-10Cr', month: 'Dec 2025' },
    { id: 5, customer: 'TechCorp Ltd', plan: 'Premium', category: 'IT Services', state: 'Karnataka', dept: 'CERT-IN', tender: 'Cybersecurity Infrastructure', tenderVal: '₹8.1Cr', bidVal: '₹7.2Cr', discount: 11.1, rank: 'L2', result: 'Lost', range: '5-10Cr', month: 'Jan 2026' },
    { id: 6, customer: 'Global Logistics', plan: 'Primary', category: 'Logistics', state: 'Tamil Nadu', dept: 'Chennai Port', tender: 'Cargo Handling Automation', tenderVal: '₹7.8Cr', bidVal: '₹6.9Cr', discount: 11.5, rank: 'L2', result: 'Lost', range: '5-10Cr', month: 'Dec 2025' },
    { id: 7, customer: 'BuildPro Solutions', plan: 'Advanced', category: 'Construction', state: 'Maharashtra', dept: 'NHAI', tender: 'Road Widening Project Phase 2', tenderVal: '₹7.6Cr', bidVal: '₹6.7Cr', discount: 11.8, rank: 'L1', result: 'Won', range: '5-10Cr', month: 'Oct 2025' },
    { id: 8, customer: 'TechCorp Ltd', plan: 'Premium', category: 'IT Services', state: 'Karnataka', dept: 'NIC', tender: 'IT Infrastructure Modernization', tenderVal: '₹6.5Cr', bidVal: '₹5.12Cr', discount: 21.2, rank: 'L1', result: 'Won', range: '5-10Cr', month: 'Dec 2025' },
    { id: 9, customer: 'PowerGrid Systems', plan: 'Advanced', category: 'Electrical', state: 'Maharashtra', dept: 'NTPC', tender: 'Sub-Station Upgrade - Phase 3', tenderVal: '₹5.8Cr', bidVal: '₹5.1Cr', discount: 12.1, rank: 'L1', result: 'Won', range: '2-5Cr', month: 'Oct 2025' },
    { id: 10, customer: 'InnovateTech', plan: 'Advanced', category: 'IT Services', state: 'Telangana', dept: 'GHMC', tender: 'Smart City Software Platform', tenderVal: '₹5.6Cr', bidVal: '₹4.9Cr', discount: 12.5, rank: 'L1', result: 'Won', range: '2-5Cr', month: 'Dec 2025' },
    { id: 11, customer: 'TechCorp Ltd', plan: 'Premium', category: 'IT Services', state: 'Karnataka', dept: 'IR', tender: 'Network Equipment - Railways', tenderVal: '₹4.5Cr', bidVal: '₹4.1Cr', discount: 8.9, rank: 'L3', result: 'Lost', range: '2-5Cr', month: 'Jan 2026' },
    { id: 12, customer: 'MedHealth Systems', plan: 'Premium', category: 'Healthcare', state: 'Gujarat', dept: 'AIIMS', tender: 'Medical Equipment Procurement', tenderVal: '₹4.8Cr', bidVal: '₹3.94Cr', discount: 17.9, rank: 'L2', result: 'Lost', range: '2-5Cr', month: 'Dec 2025' },
    { id: 13, customer: 'BuildPro Solutions', plan: 'Advanced', category: 'Construction', state: 'Maharashtra', dept: 'PWD', tender: 'Office Building - PWD', tenderVal: '₹3.2Cr', bidVal: '₹2.9Cr', discount: 9.4, rank: 'L2', result: 'Lost', range: '2-5Cr', month: 'Nov 2025' },
    { id: 14, customer: 'PowerGrid Systems', plan: 'Advanced', category: 'Electrical', state: 'Maharashtra', dept: 'MSEB', tender: 'Electrical Equipment Supply', tenderVal: '₹3.2Cr', bidVal: '₹2.78Cr', discount: 13.1, rank: 'L1', result: 'Won', range: '2-5Cr', month: 'Nov 2025' },
    { id: 15, customer: 'TechCorp Ltd', plan: 'Premium', category: 'IT Services', state: 'Karnataka', dept: 'NMMC', tender: 'Software - Smart City', tenderVal: '₹3.2Cr', bidVal: '₹2.75Cr', discount: 14.1, rank: '—', result: 'Pending', range: '2-5Cr', month: 'Dec 2025' },
    { id: 16, customer: 'Semiconductors Ltd', plan: 'Premium', category: 'Electronics', state: 'Karnataka', dept: 'BEL', tender: 'Control Panel Fabrication', tenderVal: '₹2.4Cr', bidVal: '₹1.9Cr', discount: 20.8, rank: 'L1', result: 'Won', range: '1-2Cr', month: 'Nov 2025' },
    { id: 17, customer: 'InnovateTech', plan: 'Advanced', category: 'IT Services', state: 'Telangana', dept: 'NIC', tender: 'e-Governance Portal Upgrade', tenderVal: '₹2.1Cr', bidVal: '₹1.84Cr', discount: 12.4, rank: 'L1', result: 'Won', range: '1-2Cr', month: 'Oct 2025' },
  ];

  // Helper styles
  const filterLabelStyle = { fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '0.25rem' };
  const filterInputStyle = { border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '0.8rem', color: '#4b5563', height: '34px', boxShadow: 'none' };

  // Helper function for the mini discount bar chart
  const getDiscountColor = (discount) => {
    if (discount < 10) return '#16a34a'; // Green
    if (discount < 20) return '#d97706'; // Orange
    return '#dc2626'; // Red
  };

  // Helper for Plan badges
  const renderPlanBadge = (plan) => {
    let bg, color, border;
    if (plan === 'Premium') { bg = '#f3e8ff'; color = '#7e22ce'; border = '#e9d5ff'; }
    else if (plan === 'Advanced') { bg = '#e0f2fe'; color = '#0369a1'; border = '#bae6fd'; }
    else { bg = '#ccfbf1'; color = '#0f766e'; border = '#99f6e4'; }
    return <span className="px-2 py-1" style={{ backgroundColor: bg, color: color, border: `1px solid ${border}`, borderRadius: '12px', fontSize: '0.65rem', fontWeight: '600' }}>{plan}</span>;
  };

  // Helper for Result badges
  const renderResultBadge = (result) => {
    let bg, color;
    if (result === 'Won') { bg = '#dcfce7'; color = '#166534'; }
    else if (result === 'Lost') { bg = '#fee2e2'; color = '#991b1b'; }
    else { bg = '#fef3c7'; color = '#92400e'; }
    return <span className="px-2 py-1" style={{ backgroundColor: bg, color: color, borderRadius: '4px', fontSize: '0.65rem', fontWeight: '600' }}>{result}</span>;
  };

  // Helper for Rank colors
  const getRankColor = (rank) => {
    if (rank === 'L1') return '#16a34a';
    if (rank === 'L2') return '#2563eb';
    if (rank === 'L3') return '#d97706';
    return '#6b7280';
  };

  return (
<div className="container-fluid py-4" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>      
      {/* Page Header */}
      <div className="mb-4">
        <h3 style={{ fontWeight: '700', color: '#111827', margin: 0 }}>Pricing Analytics</h3>
        <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: '4px 0 0 0' }}>Customer-wise bid spend, average pricing, win leaderboard and price breakdown</p>
      </div>

      {/* Filters Section */}
      <div className="card bg-white p-3 mb-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 style={{ fontWeight: '700', color: '#111827', margin: 0 }}>Filters</h6>
          <span className="badge" style={{ backgroundColor: '#ccfbf1', color: '#0f766e', padding: '0.4rem 0.8rem', fontWeight: '600', fontSize: '0.75rem' }}>23 records matched</span>
        </div>

        {/* Row 1 Filters */}
        <div className="row g-3 mb-3">
          {['CUSTOMER', 'PLAN', 'CATEGORY', 'STATE', 'DEPARTMENT', 'MONTH'].map((label, idx) => (
            <div className="col-lg-2 col-md-4 col-sm-6" key={idx}>
              <div style={filterLabelStyle}>{label}</div>
              <input type="text" className="form-control" defaultValue="All" style={filterInputStyle} />
            </div>
          ))}
        </div>

        {/* Row 2 Filters */}
        <div className="row g-3 align-items-end">
          <div className="col"><div style={filterLabelStyle}>RESULT</div><input type="text" className="form-control" defaultValue="All" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>RANK</div><input type="text" className="form-control" defaultValue="All" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>PRICE RANGE</div><input type="text" className="form-control" defaultValue="All" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>MIN BID (CR)</div><input type="text" className="form-control" defaultValue="-2" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>MAX BID (CR)</div><input type="text" className="form-control" placeholder="e.g. 10" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>MIN DISC %</div><input type="text" className="form-control" placeholder="e.g. 5" style={filterInputStyle} /></div>
          <div className="col"><div style={filterLabelStyle}>MAX DISC %</div><input type="text" className="form-control" placeholder="e.g. 25" style={filterInputStyle} /></div>
          <div className="col">
            <div style={filterLabelStyle}>SORT BY</div>
            <div className="input-group">
              <input type="text" className="form-control" defaultValue="Bid Value" style={{...filterInputStyle, borderRight: 'none'}} />
              <button className="btn btn-outline-secondary px-2" style={{ border: '1px solid #e5e7eb', height: '34px', backgroundColor: '#f9fafb' }}>↓</button>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-sm" style={{ border: '1px solid #fee2e2', color: '#dc2626', backgroundColor: '#fff', fontSize: '0.75rem', fontWeight: '600' }}>Reset All Filters</button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="row g-3 mb-4">
        {[
          { title: 'TOTAL BID SPEND', value: '₹106.12 Cr', subtext: 'All filtered bids', valColor: '#111827' },
          { title: 'WON BID SPEND', value: '₹49.45 Cr', subtext: 'Winning bids only', valColor: '#16a34a' },
          { title: 'AVG BID VALUE', value: '₹4.61 Cr', subtext: 'Per bid record', valColor: '#111827' },
          { title: 'AVG DISCOUNT', value: '14.3%', subtext: 'Off tender estimate', valColor: '#111827' },
          { title: 'BIDS WON', value: '12', subtext: 'of 23 bids', valColor: '#111827' },
          { title: 'WIN RATE', value: '52.2%', subtext: 'Filtered records', valColor: '#0f766e' },
        ].map((card, idx) => (
          <div className="col" key={idx} style={{ minWidth: '16%' }}>
            <div className="card h-100 bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="mb-2" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>{card.title}</h6>
              <h3 className="mb-1" style={{ fontWeight: '700', color: card.valColor, fontSize: '1.4rem' }}>{card.value}</h3>
              <p className="mb-0" style={{ fontSize: '0.7rem', color: '#6b7280' }}>{card.subtext}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="d-flex gap-4 mb-4" style={{ borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ paddingBottom: '10px', borderBottom: '2px solid #0f766e', color: '#0f766e', fontWeight: '600', fontSize: '0.85rem' }}>Full Bid Records</div>
      </div>

      {/* Compact Data Table */}
      <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
        <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
          <h6 className="fw-bold mb-0" style={{ color: '#111827' }}>All Bid Records (23)</h6>
          <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#0f766e', color: 'white', fontSize: '0.75rem', fontWeight: '600', borderRadius: '16px', padding: '0.25rem 1rem' }}>
            Export CSV
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle mb-0" style={{ fontSize: '0.7rem', whiteSpace: 'nowrap' }}>
            <thead>
              <tr style={{ color: '#6b7280', fontSize: '0.6rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' }}>
                <th className="py-2 px-3 border-bottom-0">#</th>
                <th className="py-2 border-bottom-0">CUSTOMER</th>
                <th className="py-2 border-bottom-0">PLAN</th>
                <th className="py-2 border-bottom-0">CATEGORY</th>
                <th className="py-2 border-bottom-0">STATE</th>
                <th className="py-2 border-bottom-0">DEPT</th>
                <th className="py-2 border-bottom-0">TENDER</th>
                <th className="py-2 border-bottom-0 text-end">TENDER VAL</th>
                <th className="py-2 border-bottom-0 text-end">BID VALUE</th>
                <th className="py-2 border-bottom-0 px-3">DISCOUNT</th>
                <th className="py-2 border-bottom-0 text-center">RANK</th>
                <th className="py-2 border-bottom-0 text-center">RESULT</th>
                <th className="py-2 border-bottom-0">RANGE</th>
                <th className="py-2 border-bottom-0">MONTH</th>
              </tr>
            </thead>
            <tbody>
              {bidRecords.map((row) => (
                <tr key={row.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td className="px-3 py-1 text-muted">{row.id}</td>
                  <td className="py-1" style={{ fontWeight: '600', color: '#0f766e' }}>{row.customer}</td>
                  <td className="py-1">{renderPlanBadge(row.plan)}</td>
                  <td className="py-1 text-muted">{row.category}</td>
                  <td className="py-1 text-muted">{row.state}</td>
                  <td className="py-1 text-muted">{row.dept}</td>
                  <td className="py-1" style={{ color: '#374151' }}>{row.tender}</td>
                  <td className="py-1 text-end text-muted">{row.tenderVal}</td>
                  <td className="py-1 text-end" style={{ fontWeight: '700', color: '#111827' }}>{row.bidVal}</td>
                  <td className="py-1 px-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: '24px', height: '4px', backgroundColor: '#e5e7eb', borderRadius: '2px', overflow: 'hidden' }}>
                        <div style={{ width: `${Math.min(row.discount * 4, 100)}%`, height: '100%', backgroundColor: getDiscountColor(row.discount), borderRadius: '2px' }}></div>
                      </div>
                      <span style={{ fontWeight: '600', color: getDiscountColor(row.discount) }}>{row.discount}%</span>
                    </div>
                  </td>
                  <td className="py-1 text-center" style={{ fontWeight: '700', color: getRankColor(row.rank) }}>{row.rank}</td>
                  <td className="py-1 text-center">{renderResultBadge(row.result)}</td>
                  <td className="py-1 text-muted">{row.range}</td>
                  <td className="py-1 text-muted">{row.month}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PricingAnalysis;